import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "../";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const getPersonNumber = () => {
  return dispatch => {
    dispatch({ type: "GET_PERSON_NUMBER_LOADING" });
    api
      .personNumberGet()
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "FetchPersonNumberAlertTitle",
          "Virhe seuraavan vapaan henkilönumeron noutamisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_PERSON_NUMBER_SUCCEEDED",
  payload: { personNumber: data },
});

const operationFail = () => ({
  type: "GET_PERSON_NUMBER_FAIL"
});
